/**
 * Created by PJPERF on 05.04.2017.
 */
import React from 'react'
import Button from './controls/button'
import InputField from './controls/inputfield'
import InputFilter from './controls/inputfilter'
import SelectField from './controls/selectfield';

class TableControl extends React.Component {
    handleSearch(result) {
        this.props.handleSearch(result);
    }
    handleFilter(result) {
        if (!this.props.handleFilter) return;
        this.props.handleFilter(result);
    }
    handleRPP(result) {
        this.props.handleSetRPP(result);
        this.props.handleSetPage(1);
    }
    handlePP() {
        if (this.props.navigation.page > 1) this.props.handleSetPage(this.props.navigation.page - 1);
    }
    handleNP() {
        if (this.props.navigation.page < this.props.navigation.max_pages) this.props.handleSetPage(this.props.navigation.page + 1);
    }
    handleFP() {
        this.props.handleSetPage(1);
    }
    handleLP() {
        this.props.handleSetPage(this.props.navigation.max_pages);
    }
    showSearch() {
        return (
            <div className="table_search">
                <InputFilter placeholder="search" name="search" label="" onChange={this.handleSearch.bind(this)} value={this.props.search} />
            </div>
        )
    }
    showFilter() {
        if (!this.props.filter) return null;
        return (
            <div className="table_search">
                <SelectField
                    className="small"
                    allowEmpty
                    name="company_id"
                    options={this.props.filter.options}
                    onChange={this.handleFilter.bind(this)}
                    value={this.props.filter.value}
                />
            </div>
        )
    }
    showNavigation() {
        if (this.props.navigation) {
            let disabled_back = (this.props.navigation.page === 1) ? 'disabled' : 'enabled';
            let disabled_next = (this.props.navigation.page === this.props.navigation.max_pages) ? 'disabled' : 'enabled';
            let records_info = 'Total records: ' + this.props.navigation.total_rows + ' Page: ' + this.props.navigation.page + ' from ' + this.props.navigation.max_pages;
            return (
                <div className="table_navigation">
                    <div className="info">
                        <div className='info_labels'>
                            <p className="records_info">Show records on page</p>
                            <p className="records_nav">{records_info}</p>
                        </div>
                        <InputField name="rpp" label="" onChange={this.handleRPP.bind(this)} value={this.props.navigation.rpp} input_control={
                            { numericOnly: true, blocks: [2] }} />
                    </div>
                    <div className="button_block">
                        <Button name="first_page" onClick={this.handleFP.bind(this)} status={disabled_back}>
                            <span className="glyphicon glyphicon-fast-backward" aria-hidden="true" aria-label="DOOR"></span>
                        </Button>
                        <Button name="prev_page" onClick={this.handlePP.bind(this)} status={disabled_back}>
                            <span className="glyphicon glyphicon-backward" aria-hidden="true" aria-label="DOOR"></span>
                        </Button>
                        <Button name="next_page" onClick={this.handleNP.bind(this)} status={disabled_next}>
                            <span className="glyphicon glyphicon-forward" aria-hidden="true" aria-label="DOOR"></span>
                        </Button>
                        <Button name="last_page" onClick={this.handleLP.bind(this)} status={disabled_next}>
                            <span className="glyphicon glyphicon-fast-forward" aria-hidden="true" aria-label="DOOR"></span>
                        </Button>
                    </div>
                </div>
            )
        } else {
            return null;
        }
    }
    render() {

        return (
            <div className="table_control">
                {this.showSearch()}
                {this.showFilter()}
                {this.showNavigation()}
            </div>
        )

    }
}

export default TableControl;